import type { ReusedOptions } from '../../../types/ReusedOptions.js';

export interface LinkOptions extends Pick<ReusedOptions, 'cache' | 'logResolveMap'> {
  /**
   * Url to link to a remote session. See ../createRemoteApiUrls.ts for details.
   */
  remote: string | boolean;

  /**
   * Ignore these packages when linking.
   * This can be used for packages in the current repo that have issues being bundled.
   */
  ignore?: string[];

  /** Link all internal packages discovered within the linked repo's graph. */
  all?: boolean;

  /** Don't apply resolutions from the host repo's package.json to linked packages. */
  ignoreResolutions?: boolean | string[];

  /**
   * Strategy to use when resolving linked packages.
   * - `"dedupe"`: Attempt to dedupe packages from the resolve map by removing all but the
   *   highest version that satisfies semver requirements from all parent entries.
   * - `"duplicate"`: Allow duplicates in the resolve map (don't bump dependencies).
   * @default "dedupe"
   */
  resolveStrategy: 'dedupe' | 'duplicate';
}
